import Util from '../RegistrationUtil'
import Field from '../RegistrationField'

function Phone(opts) {
    Field.call(this, opts)

    this.$input = this.$html.find('input')
}

Util.inherit(Phone, Field, {
    getClassName: function() {
        return 'textbox phone'
    },

    buildHtml: function() {
        return (
            '<input type="tel" ' +
            this._getPlaceholderText(true) +
            ' ' +
            this._getAltText(true) +
            ' id="' +
            this._getId() +
            '" />'
        )
    },

    applyBindings: function() {
        var self = this

        this.$input.on('change', function() {
            self.setValue($(this).val())
        })
        this.$input.on('focus', this.focus.bind(this))
        this.$input.on('blur', this.blur.bind(this))
    },

    updateView: function() {
        Field.prototype.updateView.call(this)
        this.$input.val(this.value)
    },
})

export default Phone
